import { Mfe, Env, Device, Url, GlobalInfo } from '@nio-pow/mfe-vue3'

function initGlobalInfo() {
  // 当前环境
  GlobalInfo.set('env', Env.getEnv())

  // 当前版本（国内/海外）
  GlobalInfo.set('appType', Env.getAppType())

  // 手动创建/加载子应用
  if (!GlobalInfo.get('createMicroApp')) {
    GlobalInfo.set('createMicroApp', Mfe.createMicroApp)
  }

  // appSystemInfo 如 client container 等
  const { lang, region } = Env.getLangRegion()
  const client = Device.isMobile() ? 'mobile' : 'pc'
  const container = 'browser'
  const appSystemInfo = Url.getAppSystemInfoFromUrl()
  GlobalInfo.set('appSystemInfo', {
    lang,
    region,
    client,
    container,
    ...appSystemInfo,
  })
}

initGlobalInfo()
Url.initStatusBarHeightStyle()
